import type { Check } from '@mui/icons-material';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../../StructuredContentRenderer';
import { ICON_BACKGROUND_SIZE, ICON_SIZE } from './constants';

type Bullet = string | StructuredContentDocument;

export const PanelColumn = ({
  title,
  items,
  borderColor,
  headerTextColor,
  headerBgColor,
  iconChipBgColor,
  Icon,
  iconColor,
}: {
  title: string;
  items: Bullet[];
  borderColor: string;
  headerTextColor: string;
  headerBgColor: string;
  iconChipBgColor: string;
  Icon: typeof Check;
  iconColor: 'success' | 'error';
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        border: '1px solid',
        borderColor,
        borderRadius: '0.5rem',
      }}
    >
      <Typography
        variant="textBold"
        sx={{
          display: 'block',
          color: headerTextColor,
          backgroundColor: headerBgColor,
          px: 3,
          py: 2,
          borderTopLeftRadius: '0.5rem',
          borderTopRightRadius: '0.5rem',
        }}
      >
        {title}
      </Typography>

      <List
        sx={{
          p: 3,
          '& > *:not(:last-child)': { mb: 3 },
        }}
      >
        {items.map((bullet, index) => (
          <ListItem
            disablePadding
            key={`${title.toLowerCase()}-bullet-${index}`}
            sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}
          >
            <Box
              sx={{
                display: 'grid',
                placeItems: 'center',
                borderRadius: '50%',
                marginTop: 0.25,
                bgcolor: iconChipBgColor,
                minWidth: ICON_BACKGROUND_SIZE,
                minHeight: ICON_BACKGROUND_SIZE,
                svg: { width: ICON_SIZE, height: ICON_SIZE },
              }}
            >
              <Icon color={iconColor} />
            </Box>
            <ListItemText
              sx={{
                margin: 0,
                padding: 0,
                '& .MuiListItemText-primary': {
                  margin: 0,
                },
                '& .MuiListItemText-secondary': {
                  margin: 0,
                },
              }}
            >
              {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
